import { registerPlugin, Capacitor } from '@capacitor/core';

interface TripRecorderPlugin {
  start(options: { rideId: string; uploadUrl: string; token: string }): Promise<void>;
  stop(): Promise<void>;
}

// Bridges to the native Android foreground-service recorder (see
// TripRecorderPlugin.java). No-ops on web, where background mic capture isn't
// possible - recording is a native-app-only safety feature.
const TripRecorder = registerPlugin<TripRecorderPlugin>('TripRecorder');

let recordingRideId: string | null = null;

export function isRecording(): boolean {
  return recordingRideId !== null;
}

export async function startTripRecording(rideId: string): Promise<void> {
  if (!Capacitor.isNativePlatform() || !rideId) return;
  if (recordingRideId === rideId) return; // already recording this trip
  const token = localStorage.getItem('accessToken') || '';
  const uploadUrl = (process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/v1/safety/recording';
  try {
    await TripRecorder.start({ rideId, uploadUrl, token });
    recordingRideId = rideId;
  } catch {
    /* permission denied or plugin missing (old build) - stay silent */
  }
}

export async function stopTripRecording(): Promise<void> {
  if (!Capacitor.isNativePlatform() || recordingRideId === null) return;
  recordingRideId = null;
  try { await TripRecorder.stop(); } catch { /* ignore */ }
}
